export const SEO_CONFIG = {
  default: {
    title: "Flexaura — Finance Life's Biggest Milestones",
    description: "Spread the cost of travel, school fees and healthcare across monthly payments with trusted BNPL providers. UAE's leading financing marketplace.",
    image: "https://flexaura.me/og-default.jpg",
    url: "https://flexaura.me",
  },
  travel: {
    title: "Flex Travel — Book Holidays on Monthly Payments | Flexaura",
    description: "Book flights, hotels and holiday packages and pay monthly with Tabby, Tamara or Cashew. No interest. UAE-wide coverage.",
    image: "https://flexaura.me/og-travel.jpg",
  },
  education: {
    title: "Flex Education — Spread School Fees Monthly | Flexaura",
    description: "Pay UAE school and university fees in monthly instalments. British, American, IB and CBSE curricula. Starting from AED 500/month.",
    image: "https://flexaura.me/og-education.jpg",
  },
  healthcare: {
    title: "Flex Healthcare — Finance Medical Treatments | Flexaura",
    description: "Finance dental, cosmetic, bariatric and specialist healthcare in the UAE. Pay monthly with trusted BNPL providers.",
    image: "https://flexaura.me/og-healthcare.jpg",
  },
  auth: {
    title: "Sign In | Flexaura",
    description: "Sign in to your Flexaura account to manage bookings, points and rewards.",
  },
  dashboard: {
    title: "My Account | Flexaura",
    description: "Manage your bookings, points and rewards.",
  },
  faq: {
    title: "FAQ — Frequently Asked Questions | Flexaura",
    description: "Everything you need to know about financing with Flexaura.",
  },
  partners: {
    title: "Partner with Flexaura | List Your Business",
    description: "Join UAE's leading BNPL marketplace. List your travel, education or healthcare business and reach thousands of GCC families.",
  },
} as const;

export type SEOPage = keyof typeof SEO_CONFIG;
